var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:reset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 16C13.671 16 15 14.669 15 13C15 11.331 13.671 10 12 10C10.329 10 9 11.331 9 13C9 14.669 10.329 16 12 16Z",
    fill: "#0A3B70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.817 11.186C20.5824 10.034 20.1218 8.93998 19.462 7.967C18.8156 7.00844 17.9906 6.1834 17.032 5.537C16.0578 4.87947 14.9642 4.41914 13.813 4.182C13.2081 4.05913 12.5922 3.99882 11.975 4.002V2L8 5L11.975 8V6.002C12.459 6 12.943 6.046 13.41 6.142C14.3047 6.32638 15.1547 6.6841 15.912 7.195C16.6585 7.69815 17.3009 8.34055 17.804 9.087C18.5852 10.2423 19.0018 11.6054 19 13C19.0007 13.936 18.8137 14.8626 18.45 15.725C18.2741 16.1408 18.0585 16.5387 17.806 16.913C17.5541 17.2861 17.2667 17.6341 16.948 17.952C15.9799 18.9181 14.7511 19.5808 13.412 19.859C12.4808 20.0478 11.5212 20.0478 10.59 19.859C9.69486 19.6744 8.84452 19.3164 8.087 18.805C7.34145 18.3022 6.69976 17.6605 6.197 16.915C5.41678 15.7584 4.99995 14.3951 5 13H3C2.99985 14.7939 3.53578 16.5469 4.539 18.034C5.18692 18.9901 6.01092 19.8141 6.967 20.462C8.45262 21.4675 10.2061 22.0033 12 22C12.6093 22.0006 13.2171 21.9392 13.814 21.817C14.9648 21.5797 16.0581 21.1194 17.032 20.462C17.5099 20.1392 17.9556 19.7711 18.363 19.363C18.7715 18.9553 19.1399 18.5092 19.463 18.031C20.4677 16.5458 21.0032 14.7931 21 13C21.0006 12.3907 20.9392 11.7829 20.817 11.186Z",
    fill: "#0A3B70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.85f932fbffb0d37059d1be12c67a530e.svg";
export { ForwardRef as ReactComponent };